import { Log } from "features/shared/types/info";

export enum LogAction {
    SET_LOGS = "[LogAction] SET_LOGS",
}

interface SetLogs {
    type: LogAction.SET_LOGS;
    logs: Log[];
}

export type LogActionTypes = SetLogs;
